var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-col',{attrs:{"cols":"3"}},[_c('v-card',[_c('v-card-title',[_vm._v(" Prizes ")]),_c('v-card-text',[_vm._v(" View available prizes! ")]),_c('v-card-actions',[_c('PrizeList',{attrs:{"current-user":_vm.currentUser}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }